<template>
    <div v-if="freelancers" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <UserCard v-for="freelancer in freelancers" :key="freelancer.id" :user="freelancer" />
    </div>
</template>

<script>
export default {
    props: {
        num: {
            type: Number,
            default: 4
        }
    },

    data() {
        return {
            freelancers: null
        };
    },

    mounted() {
        this.fetchFreelancers();
    },

    methods: {
        fetchFreelancers() {
            axios(`/api/profiles?limit=${this.num}`).then(response => {
                this.freelancers = response.data.data;
            });
        }
    }
};
</script>
